export default "__VITE_ASSET__DzjwDOxa__"